// export const parentAPI = "http://localhost/app/internal/";
// export const parentAPI2 = "http://localhost/app/";
export const parentAPI = "https://beta.tenvicsports.com/app/internal/";
export const parentAPI2 = "https://beta.tenvicsports.com/app/";

// Manipur Login
export const ManipurLogin = parentAPI + "login";

// Manipur Logout
export const ManipurLogout = parentAPI + "logout";

// Manipur Refresh Token
export const ManipurRefreshToken = parentAPI + "userrefreshtoken";

// Manipur ChangePassword
export const ManipurChangePassword = parentAPI + "changepassword";

// Manipur Forgot Password
export const ForgotPasswordLink = parentAPI + "forgotpassword";

// Manipur Reset Password
export const ResetPassword = parentAPI + "resetpassword";

// Validate Password Token 
export const ValidatePasswordToken = parentAPI + "validatetoken";

// Account type
export const AccountType = parentAPI + "accounttype";

// Menu List based on roles
export const GetUserMenus = parentAPI + "usermenu";

// Roles list
export const RolesList = parentAPI + "listrole";

// get specific role
export const GetRole = parentAPI + "getrole";

// create role
export const AddRole = parentAPI + "createrole";

// update role
export const UpdateRole = parentAPI + "updaterole";

// delete role
export const DeleteRole = parentAPI + "deleterole";

// Permissions list
export const PermissionsList = parentAPI + "listpermission";

// get specific permission
export const GetPermission = parentAPI + "getpermission";

// create permission
export const AddPermission = parentAPI + "createpermission";

// update Permission
export const UpdatePermission = parentAPI + "updatepermission";

// delete permission
export const DeletePermission = parentAPI + "deletepermission";

// Role Permissions list
export const RolePermissionsList = parentAPI + "listrolepermission";

// get specific role permission
export const GetRolePermission = parentAPI + "getrolepermission";

// create role permission
export const AddRolePermission = parentAPI + "createrolepermission";

// update role Permission
export const UpdateRolePermission = parentAPI + "updaterolepermission";

// delete role permission
export const DeleteRolePermission = parentAPI + "deleterolepermission";

// menu list
export const MenuList = parentAPI + "listmenu";

// menu list by account id
export const MenuListByAccountId = parentAPI + "listaccountmenu";

// get specific menu
export const GetMenu = parentAPI + "getmenu";

// create menu
export const AddMenu = parentAPI + "createmenu";

// update menu
export const UpdateMenu = parentAPI + "updatemenu";

// delete menu
export const DeleteMenu = parentAPI + "deletemenu";

// menu role list
export const MenuRoleList = parentAPI + "listmenurole";

// get specific menu role
export const GetMenuRole = parentAPI + "getmenurole";

// create menu role
export const AddMenuRole = parentAPI + "createmenurole";

// update menu role
export const UpdateMenuRole = parentAPI + "updatemenurole";

// delete menu role
export const DeleteMenuRole = parentAPI + "deletemenurole";

// submenu list
export const SubMenuList = parentAPI + "listsubmenu";

// get submenu 
export const GetSubMenu = parentAPI + "getsubmenu";

// get submenu by menu id
export const GetSubMenuByMenu = parentAPI + "listsubmenubymenu";

// create sub menu
export const AddSubMenu = parentAPI + "createsubmenu";

// update submenu
export const UpdateSubMenu = parentAPI + "updatesubmenu";

// delete menu role
export const DeleteSubMenu = parentAPI + "deletesubmenu";

// list user rbac
export const ListUserRBAC = parentAPI + "listuserrbac";

// get user rbac
export const GetUserRBAC = parentAPI + "getuserrbac";

// create user rbac
export const CreateUserRBAC = parentAPI + "createuserrbac";

// update user rbac
export const UpdateUserRBAC = parentAPI + "updateuserrbac";

// delete user rbac
export const DeleteUserRBAC = parentAPI + "deleteuserrbac";

// list users
export const ListUsers = parentAPI + "listuser";

// get user
export const GetUser = parentAPI + "getuser";

// create user
export const CreateUser = parentAPI + "register";

// update user
export const UpdateUser = parentAPI + "updateuser";

// delete user
export const DeleteUser = parentAPI + "deleteuser";

// list sports
export const ListSports = parentAPI + "listsport";

// get sport
export const GetSport = parentAPI + "getsport";

// create sport
export const CreateSport = parentAPI + "createsport";

// update sport
export const UpdateSport = parentAPI + "updatesport";

// delete sport
export const DeleteSport = parentAPI + "deletesport";

// list talent scouting
export const ListTalentScouting = parentAPI + "listtalentscouting";

// get talent scouting
export const GetTalentScouting = parentAPI + "gettalentscouting";

// create talent scouting
export const CreateTalentScouting = parentAPI + "createtalentscouting";

// update talent scouting
export const UpdateTalentScouting = parentAPI + "updatetalentscouting";

// delete talent scouting
export const DeleteTalentScouting = parentAPI + "deletetalentscouting";

// list talent scouting selection criteria
export const ListTalentScoutingSelectionCriteria = parentAPI + "listselectioncriteria";

// get talent scouting selection criteria
export const GetTalentScoutingSelectionCriteria = parentAPI + "getselectioncriteria";

// create talent scouting selection criteria
export const CreateTalentScoutingSelectionCriteria = parentAPI + "createselectioncriteria";

// update talent scouting selection criteria
export const UpdateTalentScoutingSelectionCriteria = parentAPI + "updateselectioncriteria";

// delete talent scouting selection criteria
export const DeleteTalentScoutingSelectionCriteria = parentAPI + "deleteselectioncriteria";

// list geo state
export const ListGeoState = parentAPI + "listgeography";

// get geo state
export const GetGeoState = parentAPI + "getgeography";

// create geo state
export const CreateGeoState = parentAPI + "creategeography";

// update geo state
export const UpdateGeoState = parentAPI + "updategeography";

// delete geo state
export const DeleteGeoState = parentAPI + "deletegeography";

// list geo district
export const ListGeoDistricts = parentAPI + "listdistrict";

// get geo district
export const GetGeoDistrict = parentAPI + "getdistrict";

// create geo district
export const CreateGeoDistrict = parentAPI + "createdistrict";

// update geo district
export const UpdateGeoDistrict = parentAPI + "updatedistrict";

// delete geo district
export const DeleteGeoDistrict = parentAPI + "deletedistrict";

// list geo district by stateid
export const ListGeoDistrictsByStateId = parentAPI + "listdistrictbygeography";

// list geo city
export const ListGeoCity = parentAPI + "listcity";

// get geo city
export const GetGeoCity = parentAPI + "getcity";

// create geo city
export const CreateGeoCity = parentAPI + "createcity";

// update geo city
export const UpdateGeoCity = parentAPI + "updatecity";

// delete geo city
export const DeleteGeoCity = parentAPI + "deletecity";

// list geo city by districtid
export const ListGeoCityByDistrictId = parentAPI + "listcitybydistrict";

// list geo center
export const ListGeoCenter = parentAPI + "listcenter";

// get geo center
export const GetGeoCenter = parentAPI + "getcenter";

// create geo center
export const CreateGeoCenter = parentAPI + "createcenter";

// update geo center
export const UpdateGeoCenter = parentAPI + "updatecenter";

// delete geo center
export const DeleteGeoCenter = parentAPI + "deletecenter";

// list geo center by city
export const ListGeoCentersByCityId = parentAPI + "listcenterbycity";

// list hpc center by geography
export const HPC = parentAPI + "hpc";

// list sports for athletes
export const ListAthleteSports = parentAPI + "sportlist";

// Register Athlete Basic Info
export const Athlete = parentAPI + "athlete";

// Registered Active Athlete
export const ActiveAthlete = parentAPI + "listathlete";

// Register Athlete Gaurdian Info
export const AthleteGaurdianInfo = parentAPI + "athleteguardianinfo";

// Register Athlete Sport Info
export const AthleteSportInfo = parentAPI + "athletesportinfo";

// Register email verify
export const RegisterEmailVerify = parentAPI + "emailverify";

// list batches
export const ListBatches = parentAPI + "listbatch";

// get batch
export const GetBatch = parentAPI + "getbatch";

// create batch
export const CreateBatch = parentAPI + "createbatch";

// update batch
export const UpdateBatch = parentAPI + "updatebatch";

// delete batch
export const DeleteBatch = parentAPI + "deletebatch";

// list coaches
export const ListCoaches = parentAPI + "listcoach";

// list batch athletes
export const ListBatchesAthletes = parentAPI + "listbatchathlete";

// get batch athlete
export const GetBatchAthlete = parentAPI + "getbatchathlete";

// create batch athletes
export const CreateBatchAthletes = parentAPI + "createbatchathlete";

// update batch athletes
export const UpdateBatchAthlete = parentAPI + "updatebatchathlete";

// delete batch athlete
export const DeleteBatchAthlete = parentAPI + "deletebatchathlete";

// list active athletes
export const ListActiveAthletes = parentAPI + "listathlete";

// list schedules
export const ListSchedules = parentAPI + "listschedule";

// get schedule
export const GetSchedule = parentAPI + "getschedule";

// create schedule
export const CreateSchedule = parentAPI + "createschedule";

// update schedule
export const UpdateSchedule = parentAPI + "updateschedule";

// delete schedule
export const DeleteSchedule = parentAPI + "deleteschedule";

// list assessment
export const ListAssessments = parentAPI + "listassessment";

// get assessment
export const GetAssessment = parentAPI + "getassessment";

// create assessment
export const CreateAssessment = parentAPI + "createassessment";

// list, get, create, update, delete competition
export const competitions = parentAPI + "competitions";

// list, get, create, update, delete competition type
export const competitionType = parentAPI + "competitiontype";

// list, get, create, update, delete competition sport type
export const competitionSportType = parentAPI + "competitionsporttype";

// list, get, create, update, delete competition sport
export const competitionSport = parentAPI + "competitionsport";

// list, get, create, update, delete competition performance
export const competitionPerformance = parentAPI + "competitionperformance";

// list, get, create, update, delete sports list
export const sportList = parentAPI + "cmpsportlist";

// Competition Report
export const CompetitionReport = parentAPI + "competitionsreport";

// Competition Performance Report
export const CompetitionPerformanceReport = parentAPI + "competitionperformance";

// Athlete Report
export const AthleteReport = parentAPI + "athletereport";

// Schedule Report
export const ScheduleReport = parentAPI + "schedulereport";

// Assessment Report
export const AssessmentReport = parentAPI + "testresultsreport";

// Get sport and athlete list by competition id
export const GetSportAthletesByComp = parentAPI + "competition-sport-athlete";

// List talent scouting athletes
export const ListTalentScoutingAthletes = parentAPI + "talent-scouting-athletes";

// Approve Athlete
export const ApproveAthlete = parentAPI + "approveathlete";

// Center Batch
export const CenterBatch = parentAPI + "centerbatch";

// list center active athletes
export const ListCenterActiveAthletes = parentAPI + "centerathletes";

// Center Batch Athlete
export const CenterBatchAthlete = parentAPI + "centerbatchathlete";

// list, get, create, update, delete center schedule
export const CenterSchedule = parentAPI + "centerschedule";

// list, get, create, update, delete center attendance
export const CenterAttendance = parentAPI + "centerattendance";

// list, get, create, update, delete center Assessment
export const CenterAssessment = parentAPI + "centerassessment";

// list center athletes
export const CenterBatchAthletes = parentAPI + "listcenterbatchathlete";

// Approve athlete to hpc
export const ApproveAthleteToHPC = parentAPI + "approvehpc";

// Assessment Type List
export const AssessmentType = parentAPI + "assessmenttype";

// list, get, create, update, delete skills
export const Skills = parentAPI + "skill";

// list, get, create, update, delete programs
export const Program = parentAPI + "program";

// list, get, create, update, delete schedule type
export const ScheduleType = parentAPI + "scheduletype";

// Grade Type
export const GradeType = parentAPI + "gradetype";

// Attendance Type
export const AttendanceType = parentAPI + "attendancetype";

// Athletes list based on geography and center
export const HPCAthletes = parentAPI + "athletesbyhpc";

// list, get, create, update, delete hpc batch
export const HPCBatch = parentAPI + "hpcbatch";

// list, get, create, update, delete hpc batch athlete
export const HPCBatchAthlete = parentAPI + "hpcbatchathlete";

// list, get, create, update, delete hpc schedule
export const HPCSchedules = parentAPI + "hpcschedule";

// list, get, create, update, delete hpc attendance
export const HPCAttendance = parentAPI + "hpcattendance";

// list, get, create, update, delete hpc assessment
export const HPCAssessment = parentAPI + "hpcassessment";

// list injury
export const ListInjury = parentAPI + "listinjury";

// get, create, update, delete injury
export const Injury = parentAPI + "injury";

// list injury assessment
export const ListInjuryAssessment = parentAPI + "listinjury-assessment";

// get, create, update, delete injury-assessment
export const InjuryAssessment = parentAPI + "injury-assessment";

// list injury diagnosis
export const ListInjuryDiagnosis = parentAPI + "listdiagnosis";

// get, create, update, delete injury diagnosis
export const InjuryDiagnosis = parentAPI + "diagnosis";

// list injury treatment
export const ListInjuryTreatment = parentAPI + "listtreatmentplan";

// get, create, update, delete injury treatment
export const InjuryTreatment = parentAPI + "treatmentplan";

// get, create, update, delete screening
export const Screening = parentAPI + "screening";
export const ListScreening = parentAPI + "listscreening";


/* // Filters Dropdowns API // */

// Get Coach By Center
export const GetCoachByCenterId = parentAPI + "listcoachbycenter";

// Get Sport By Coach
export const GetSportByCoachId = parentAPI + "listsportbycoach";

// Get Batches with unassigned athletes
export const GetTSUnassignedBatches = parentAPI + "unassigned_ts_batch";

// Get Batches with unassigned athletes
export const GetUnassignedBatches = parentAPI + "unassignedbatch";

// Get Batches by center
export const GetBatchesByCenter = parentAPI + "listbatchbycenter";

// Get skills by batch
export const GetSkillsByBatch = parentAPI + "listskillbycenterandbatch";

// List Schedules by center
export const GetSchedulesByCenters = parentAPI + "listschedulebybatchcenter";

// List Athletes by Schedule
export const GetAthletesBySchedule = parentAPI + "listathletebyschedule";

// List Schedules By Batch
export const GetSchedulesByBatch = parentAPI + "listschedulebybatch";

// List Athletes By Assessment
export const ListAthletesByAssessment = parentAPI + "listathletebyassement";

/* // Filters Dropdowns API HPC // */

// Get HPC By Geography
export const GetHPCByGeography = parentAPI + "hpcbygeography";

// Get Coaches By HPC
export const GetCoachesByHPC = parentAPI + "coachbyhpc";

// Get Sports By Coach
export const GetSportsByCoach = parentAPI + "listsportbycoach";

// Get Batch By HPC
export const GetBatchByHpc = parentAPI + "listbatchbyhpc";

// Get Athletes By Hpc Batch
export const GetAthletesByHpc = parentAPI + "hpcathlete";

// Get skills by geography and batch
export const GetSkillsByGeoandBatch = parentAPI + "listskillbygeobatch";

// Get schedules by geography and batch
export const GetSchedulesByGeoandBatch = parentAPI + "listschedulebygeobatch";

// Get skills by geography and batch
export const GetHPCAthletesBySchedule = parentAPI + "listathletesbyschedule";

// Get Schedules by batch
export const GetHpcSchedulesByBatch = parentAPI + "listhpcschedulebybatch";

// Get athletes by assessment
export const GetAthletesByAssessment = parentAPI + "listhpcathletebyassement";

// Metrics data
export const AthleteMetricsData = parentAPI + "athletemetricdata";

// Metric scale
export const MetricScale = parentAPI + "metricscale";

// Create Metrics
export const CreateMetrics = parentAPI + "createmetrics";

// Athlete Profile- info
export const AthleteProfileInfo = parentAPI + "profile-info";

// Blood Group
export const BloodGroup = parentAPI + "bloodgroup";

// Allergy Type
export const AllergyType = parentAPI + "allergytype";

// Medication Category
export const MedicationCtgry = parentAPI + "medicationcategory";

// Alcohol
export const Alcohol = parentAPI + "alcoholusage";

// Tobacco
export const Tobacco = parentAPI + "tobaccousage";

// Injury Type
export const InjuryType = parentAPI + "injurytype";

// Region Affected
export const RegionAffected = parentAPI + "regionaffected";

// Diagnosis Type
export const DiagnosisType = parentAPI + "diagnosistype";

// Injury Severity
export const InjurySeverity = parentAPI + "injuryseverity";

// Injury Mechanism
export const InjuryMechanism = parentAPI + "mechanisminjury";

// Injury Management Approach
export const InjuryManagement = parentAPI + "injurymanagementapproach";

// Time Lost
export const TimeLost = parentAPI + "timelostfromtraining";

// Surgery Category
export const SurgeryCategory = parentAPI + "surgerycategory";

// Body Region
export const BodyRegion = parentAPI + "bodyregion";

// Rehabilitation Duration
export const RehabilitationDuration = parentAPI + "rehabilitationduration";

// Physiological Type
export const PhysiologicalType = parentAPI + "physiologicaltype";

// Screening Test Type
export const ScreeningTestType = parentAPI + "screeningtesttype";

// Symptom Type
export const SymptomType = parentAPI + "symptomtype";

// Pain Location Type
export const PainLocationType = parentAPI + "painlocationtype";

// Functional Limitations Type
export const FunctionalLimitationsType = parentAPI + "functionallimitationstype";

// Injury Treatment Type
export const InjuryTreatmentType = parentAPI + "injurytreatmenttype";

// Concussion Specific Symptom
export const ConcussionSpecificSymptom = parentAPI + "concussionspecificsymptom";

// Onset
export const Onset = parentAPI + "onset";

// Performance Test
export const PerformanceTest = parentAPI + "performancetesttype";

// Assign Coach to Center
export const AssignCoachToCenter = parentAPI + "assigncoach";

// Assign Ops to Center
export const AssignOpsToCenter = parentAPI + "assignops";

// Assign Biz to Center
export const AssignBizToCenter = parentAPI + "assignbiz";

// Assign Coach to HPC
export const AssignCoachToHPC = parentAPI + "assignhpccoach";

// Assign Ops to HPC
export const AssignOpsToHPC = parentAPI + "assignhpcops";

// Assign Biz to HPC
export const AssignBizToHPC = parentAPI + "assignhpcbiz";

// Save Assessment (palpation)
export const SaveAssessment = parentAPI + "start";

// Overall Assessment
export const ListOverallAssessment = parentAPI + "assessment";

// Resume Overall Assessment
export const ResumeAssessment = parentAPI + "resume";

// Injury Assessment Schema
export const InjuryAssessmentSchema = parentAPI + "injury-assessment-scheme";

// Psychology Ui Schema
export const PsychologyUiSchema = parentAPI + "ui-scheme-psychological";

// Save Psychology Assessment
export const SavePsychologyAssessment = parentAPI + "start-psychological";

// list Psychology Assessment
export const ListPsychologyAssessment = parentAPI + "list-psychological";

// view Psychology Assessment details
export const ViewPsychologyAssessment = parentAPI + "scoring-psychological";

// Psychology-acsi Ui Schema
export const PsychologyAcsiUiSchema = parentAPI + "ui-scheme-psychological-acsi";

// Save Psychology-acsi Assessment
export const SavePsychologyAcsiAssessment = parentAPI + "start-psychological-acsi";

// list Psychology-acsi Assessment
export const ListPsychologyAcsiAssessment = parentAPI + "list-psychological-acsi";

// view Psychology-acsi Assessment details
export const ViewPsychologyAcsiAssessment = parentAPI + "scoring-psychological-acsi";